/* @flow */
import * as React from "react";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import TileBody from "nexia_mobile/components/Tiles/TileBody";
import prefixStyles from "nx-components/utils/prefixStyles";
import { history } from "nexia_mobile/history";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";
import UserIcon from "nexia_mobile/components/UserIcon";
import Phone from "nexia_mobile/models/phone";

const styles = prefixStyles({
  iconStyle: {
    fontSize: "3em",
  },
});

type Props = {
  model: Phone,
  tileStyles: {
    contents: Object,
    icon: Object,
    title: Object,
    status: Object,
  },
};

export default class PhoneTile extends React.Component<Props> {
  _handleTap = () => {
    const { model } = this.props;
    history.push("/app/phones/details", { phone: model });
  };

  render() {
    const { model, tileStyles } = this.props;

    let phoneName = model.get("name");

    return (
      <Tappable onTap={this._handleTap} holdActiveUntil={getTransitionPromise}>
        {({ active, tapTargetRefHandler }) => (
          <div
            data-component-name="PhoneTile"
            className="tile-contents"
            style={{
              ...tileStyles.contents,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
          >
            <TileBody innerRef={tapTargetRefHandler}>
              <UserIcon phone={model} style={styles.iconStyle} />
              <div className="tile-title" style={tileStyles.title}>
                {phoneName}
              </div>
            </TileBody>
          </div>
        )}
      </Tappable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/PhoneTile.jsx